import { Tax } from '@thro-types/billing';

import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const taxSettingsValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    key: yup.string().required(t(translations.validation.required())),
    text: yup.string().required(t(translations.validation.required())).trim(),
    taxRate: yup.number().required(t(translations.validation.required()))
  });

export const useTaxSettingsInitialValue = (initialTax: Tax | undefined) => {
  return initialTax
    ? { key: initialTax.key, text: initialTax.text, taxRate: initialTax.taxRate }
    : { key: undefined, text: undefined, taxRate: undefined };
};
